import { takeEvery, put, call, fork } from 'redux-saga/effects';
import { Client } from 'utils/client';
import {
  USER_MNGT_ONLOAD,
  // userMngtOnloadSuccess,
  userMngtOnloadFailed,
  USER_SEARCH,
  userSearchSuccessful,
  userSearchFailed,
  CE_USER_ONLOAD,
  CE_USER,
  ceUserSuccess,
  ceUserFailed,
  ceUserOnLoadSuccess
} from './actions';
import { appLogout } from 'redux-root/actions';
import { PATH_USER_READ_UPDATE, PATH_USER_SEARCH_OR_CREATE } from 'utils/appConstant'


export function* searchOnLoad(action) {
  //  try {
  //    const data = yield call(Client.getData, '/api/v1/portal/roles');
  //    yield put(userMngtOnloadSuccess(data));
  //  } catch (error) {
  //    console.log(error);
  //
  //    if (error.status === 401) {
  //      yield put(appLogout(true));
  //    } else {
  //      yield put(userMngtOnloadFailed(error));
  //    }
  //  }
}


export function* userSearchCall(action) {
  const paramObject = Object.assign({}, action.payload);
  let params = '';
  paramObject.pageNo = 0
  paramObject.pageSize = 1000

  if (paramObject.email) {
    params = `email=${paramObject.email}`;
  }
  else {
    Object.keys(paramObject).forEach(key => {
      if (params) {
        params += `&${key}=${paramObject[key]}`;
      } else {
        params += `${key}=${paramObject[key]}`;
      }
    });
  }

  try {
    const data = yield call(Client.getData, `${PATH_USER_SEARCH_OR_CREATE}?${params}`, true);

    yield put(userSearchSuccessful(data));
  } catch (error) {
    console.log(error);
    if (error.status === 401) {
      yield put(appLogout(true));
    } else
      yield put(userSearchFailed(error))
  }
}

export function* createOrEditUserOnLoad(action) {
  try {
    const data = {}
    data.roles = yield call(Client.getData, '/api/v1/portal/roles');
    yield put(ceUserOnLoadSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(userMngtOnloadFailed(error));
    }
  }
}

export function* createOrEditUser(action) {
  try {
    let data = {}
    if (action.payload.id)
      data = yield call(Client.putData, `${PATH_USER_READ_UPDATE}`, action.payload, true, { 'isListObject': false, 'id': action.payload.id });
    else
      data = yield call(Client.postData, `${PATH_USER_SEARCH_OR_CREATE}`, action.payload, true);
    yield put(ceUserSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(ceUserFailed(error));
    }
  }
}

function* watchUserMngtOnLoad() {
  yield takeEvery(USER_MNGT_ONLOAD, searchOnLoad);
}

function* watchUserSearch() {
  yield takeEvery(USER_SEARCH, userSearchCall);
}

function* watchCeUserOnLoad() {
  yield takeEvery(CE_USER_ONLOAD, createOrEditUserOnLoad);
}

function* watchCeUser() {
  yield takeEvery(CE_USER, createOrEditUser);
}

export function* userManagementSaga() {
  yield fork(watchUserMngtOnLoad);
  yield fork(watchUserSearch);
  yield fork(watchCeUserOnLoad);
  yield fork(watchCeUser);
}